import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { pendingRequestDestination } from "@/lib/requestContext";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { user, refresh } = useAuth();
  const started = useRef(false);
  const [status, setStatus] = useState(token ? "verifying" : "sent");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    api.post("/auth/verify-email", { token })
      .then(async () => {
        await refresh();
        setStatus("verified");
      })
      .catch((error) => {
        setMessage(error.response?.data?.detail || "Linket er ugyldigt eller udløbet.");
        setStatus("error");
      });
  }, [token, refresh]);

  const resend = async () => {
    setBusy(true);
    setMessage("");
    try {
      await api.post("/auth/resend-verification");
      setMessage("Vi har sendt et nyt bekræftelseslink.");
    } catch (error) {
      setMessage(error.response?.data?.detail || "Mailen kunne ikke sendes lige nu.");
    } finally {
      setBusy(false);
    }
  };

  const verified = status === "verified" || (status === "sent" && user?.email_verified_at);
  const destination = user?.role === "expert" ? "/expert/onboarding" : user?.role === "admin" ? "/admin" : pendingRequestDestination() || "/dashboard";
  return <div className="mx-auto max-w-xl px-4 py-12 sm:py-20">
    <section className="rounded-[28px] border border-brand-line bg-white p-6 text-center shadow-[0_24px_70px_rgba(45,42,38,.08)] sm:p-10">
      <p className="text-xs font-bold uppercase tracking-[.16em] text-brand-fresh">Kontosikkerhed</p>
      <h1 className="mt-3 text-3xl font-bold text-brand-ink">{verified ? "Din e-mail er bekræftet" : status === "verifying" ? "Bekræfter din e-mail…" : "Tjek din indbakke"}</h1>
      {status === "sent" && !verified && <p className="mt-4 text-sm leading-6 text-brand-body">Vi har sendt et engangslink til din e-mail. Linket virker i 24 timer.</p>}
      {verified && <><p className="mt-4 text-sm text-brand-body">Kontoen er klar til brug.</p><Link to={destination} className="btn-primary mt-6 inline-flex">Fortsæt</Link></>}
      {status === "error" && <p className="mt-4 rounded-xl bg-[#FFF1EE] p-4 text-sm text-[#991B1B]">{message}</p>}
      {status === "sent" && user && !verified && <button type="button" onClick={refresh} className="btn-primary mt-6">Jeg har bekræftet min e-mail</button>}
      {(status === "sent" || status === "error") && user && !verified && <button type="button" onClick={resend} disabled={busy} className="btn-secondary mt-6">{busy ? "Sender…" : "Send et nyt link"}</button>}
      {(status === "sent" || status === "error") && !user && <Link to="/log-ind" className="btn-secondary mt-6 inline-flex">Log ind for at sende igen</Link>}
      {message && status !== "error" && <p className="mt-4 text-sm text-brand-green" role="status">{message}</p>}
    </section>
  </div>;
}

